<template>
<div class="tw_dashboard_trading" :class="{edit: isEditMode, disabled: isDisabled}">
  <tw-table-system :schemas="schemas" :height="272" :nopager="true" :items="items" @row-click="rowClick" />
</div>
</template>

<script>
import { $api } from '@/store/ApiClient';
import TwTableSystem from '@/components/organisms/TwTableSystem';
import schemas from '@/dictionaries/dashBoardTradingStatusSchema.json';
import { EDITABLE_FLG, TRADING_REGISTRATION_STATUS } from 'lib-tw-common';

export default {
  name: 'TwDashBoardTrading',
  props: {
    isEditMode: Boolean,
    isDisabled: Boolean,
  },
  components: {
    TwTableSystem,
  },
  data() {
    return {
      schemas: schemas,
      items: null,
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      // bff_db_6 取引ステータス一覧取得
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/dashboard/trading-status',
        }
      };

      $api
        .request(params)
        .then(res => {
          this.items = res.tradingFlowList.slice(0, 5);
        })
        .catch(err => {
          this.items = [];
          this.$store.dispatch('SHOW_ALERT', err.message);
        });
    },
    rowClick(row) {
      if (row.tradingSubmitStatusCd === TRADING_REGISTRATION_STATUS.SAVING && row.editableFlg === EDITABLE_FLG.ON) {
        this.$router.push({
          name: 'SavedTrading',
          params: { tradingId: row.tradingId },
        });
      } else {
        this.$router.push({
          name: 'ManageTrading',
          params: { tradingId: row.tradingId },
          query: { expand: row.tradingFlowId }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .tw_dashboard_trading {
    position: relative;
    z-index: 2;

    &.edit {
      pointer-events: none;

      &.disabled:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(249, 249, 253, 0.5);
        border-radius: 8px;
        content: '';
      }
    }
  }
</style>